import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findIndex, reduce, intersection, indexOf } from 'lodash';
import shortid from 'shortid';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import SearchPath from '../../../../components/search-path';
import PathDisplay from '../../../../components/search-path/path';
import ConfirmButton from '../../../../components/confirm-button';

class ResellerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      currentId: null,
    };
    this.closeModal = this.closeModal.bind(this);
    this.updateSearchPath = this.updateSearchPath.bind(this);
    this.removeReseller = this.removeReseller.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }


  closeModal() {
    this.setState({ openModal: false });
  }

  updateSearchPath(field) {
    const newItems = [...this.props.resellers];
    const index = findIndex(this.props.resellers, { _id: this.state.currentId });
    if (index >= 0) {
      newItems[index] = {
        ...newItems[index],
        field,
      };
    } else {
      const id = shortid.generate();
      newItems.push({
        _id: id,
        field,
        type: 'to', // by default
      });
    }
    this.props.onChange(newItems);
    this.closeModal();
  }

  removeReseller(reseller) {
    let newItems = [...this.props.resellers];
    const index = findIndex(newItems, { _id: reseller._id });
    if (index >= 0) {
      newItems = reduce(newItems, (items, item, idx) => {
        if (idx !== index) {
          items.push(item);
        }
        return items;
      }, []);
      this.props.onChange(newItems);
    }
  }

  handleTypeChange(e) {
    const { id, value } = e.target;
    let newItems = [...this.props.resellers];
    const index = findIndex(newItems, { _id: id });
    if (index >= 0) {
      newItems = reduce(newItems, (items, item, idx) => {
        if (idx !== index) {
          items.push(item);
        } else {
          items.push({ ...item, type: value });
        }
        return items;
      }, []);
      this.props.onChange(newItems);
    }
  }


  filterNodes(node) {
    const { fields } = node;
    const validTypes = ['email'];
    return reduce(fields, (items, field) => {
      const validReference = intersection(field.reference_to, ['account', 'Account', 'User', 'systemuser']).length > 0;
      const idType = node.objectType === 'User' && field.is_key && field.type === 'id';
      const validType = indexOf(validTypes, field.type) >= 0;

      const isValid = idType || validReference || validType;
      if (isValid) {
        if (idType) {
          items.push({
            ...field,
            label: node.label,
            name: `${node.objectLabel} Info`,
          });
        } else {
          items.push(field);
        }
      }
      return items;
    }, []);
  }

  renderModal() {
    const { openModal } = this.state;
    const { isAccount } = this.props;

    return (
      <Modal show={openModal} onHide={this.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Select Recipient Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <SearchPath
              paths={[]}
              onUpdate={this.updateSearchPath}
              selectedSearchPaths={[]}
              filterNodes={this.filterNodes}
              startingNode={isAccount ? 'Account' : 'Opportunity'}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button bsStyle="default" onClick={this.closeModal}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  renderSelector(reseller) {
    return (
      <select onChange={this.handleTypeChange} className="form-control" name="type" id={reseller._id} value={reseller.type}>
        <option value="to">TO</option>
        <option value="cc">CC</option>
        <option value="bcc">BCC</option>
      </select>
    );
  }

  renderRow(reseller) {
    const { disabled, isAccount } = this.props;
    return (
      <tr key={reseller._id}>
        <td><PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={reseller.field} /></td>
        <td>
          {this.renderSelector(reseller)}
        </td>
        <td>
          <ConfirmButton
            size="sm"
            disabled={disabled}
            confirmMessage="?"
            confirmStyle="link"
            onConfirm={() => { this.removeReseller(reseller); }}
          >
            <Fa name="trash" />
          </ConfirmButton>
        </td>
      </tr>
    );
  }

  renderList() {
    const { resellers } = this.props;
    if (!resellers || resellers.length === 0) {
      return null;
    }
    return (
      <div>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Field</th>
              <th width="150">Recipient Type</th>
              <th width="50">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {resellers.map((reseller) => { return this.renderRow(reseller); })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { disabled } = this.props;
    return (
      <div>
        <div className="well well-sm">
          Add CRM field(s) to the email fields below to dynamically add additional recipients to the feedback request emails sent to a contact.
        </div>
        {this.renderList()}
        <div>
          <Button disabled={disabled} onClick={() => { this.setState({ currentId: null, openModal: true }); }} bsStyle="primary" bsSize="sm">
            <Fa name="plus" /> Add Recipient
          </Button>
        </div>
        {this.renderModal()}
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

ResellerList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  resellers: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    field: PropTypes.arrayOf(PropTypes.string),
  })),
  isAccount: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
ResellerList.defaultProps = {
  resellers: [],
  isAccount: false,
  disabled: false,
  onChange: () => {},
};

export default connect(mapStateToProps)(ResellerList);
